import React from 'react';
import './Inicio.css';
import imageninicio from '../assets/Doctores_home.png';
import selloCertificado from '../assets/Sello_certificado_NOM024.png';
import { Link } from 'react-router-dom';
import { sendEvent } from "../utils/ga4";
import { sendMetaEvent } from "../utils/metaPixel";


const Inicio = () => {
    return (
        <section id="inicio" >
            <div className="inicio-content">
                <h1>La solución <strong>más fácil</strong> para gestionar tu consultorio y tener más tiempo para ti.</h1>
                <p>
                Con Salvir, gestiona y personaliza expedientes clínicos completos,
                agenda tus citas y documenta cada consulta de principio a fin,
                en un solo lugar; cumple con la NOM-004 y NOM-024. Diseñado con cifrado avanzado y servidores en AWS.
                </p>

                <p>
                Más simple para ti. Más confianza para tus pacientes.
                </p>
                <a
                    href="http://www.dgis.salud.gob.mx/intercambio/certificados/DGIS-CER-P-021-2026-10_gobmx.html"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inicio-certificado"
                    aria-label="Consultar certificado oficial NOM-024 de Salvir"
                >
                    <img
                        src={selloCertificado}
                        alt="Sello de certificación NOM-024 de Salvir"
                        className="inicio-certificado-sello"
                    />

                    <div className="inicio-certificado-info">
                        

                        <strong>Certificado NOM-024</strong>

                        <span className="inicio-certificado-descripcion">
                            Secretaría de Salud
                        </span>

                        <span className="inicio-certificado-enlace">
                            ver certificado ↗
                        </span>
                    </div>
                </a>
               <Link
                    to="/registro"
                    onClick={() => {
                        sendEvent({
                            category: "Home",
                            action: "Registro_botón_mes_gratis",
                            label: "Promo1MesGratis",
                        });

                        // Meta Pixel — Lead
                        sendMetaEvent("Lead");
                        }}
                    >
                        <button className="inicio-button">¡Prueba gratis!</button>
                      </Link>
                
            </div>
            <div className="inicio-image">
                <img src={imageninicio} alt="Profesionales de la salud usando Salvir, expediente clínico electrónico" />
                
            </div>
        </section>
    );
};

export default Inicio;
